import React, { Component } from 'react';
import {withRouter} from 'react-router-dom'
import { Grid, Row, PageHeader } from 'react-bootstrap';
import {userData, auth, isAdmin} from "../App";
import Crummy from "../Components/Crummy";

class Profile extends Component {

    constructor(props) {
        super(props);
        const { match } = this.props;

        var currentUserId = null;
        if (auth.currentUser && !auth.currentUser.isAnonymous) {
            currentUserId = auth.currentUser.uid
            console.log("currentUserId: " + currentUserId);
        }

        if (match && match.params.id) {
            console.log(match.params.id);
            //console.log(props);
        } else {
            console.log("no match: ");
            console.log(props);
        }

        this.state = {
            id: (props.match.params.id) ? props.match.params.id:currentUserId,
            currentUserId: currentUserId
        };
    }



  componentWillMount() {
    console.log("componentWillMount");
  }

  componentWillReceiveProps(nextProps) {
    console.log("componentWillReceiveProps");


    if (this.state.id !== nextProps.match.params.id) {
      let newId = (nextProps.match.params.id) ? nextProps.match.params.id:this.state.currentUserId;
      this.setState({id: newId});
    }

  }
  shouldComponentUpdate(nextProps, nextState) {
    console.log("shouldComponentUpdate");
    return true;

  }
  componentWillUpdate() {
    console.log("componentWillUpdate");

  }

  breadcumb() {
    return (
      <Crummy
        paths={
          [
            {'name': 'Home', 'path': '/'},
          ]
        } page={'Profile'}/>
    );
  }


  render() {
      if ((!auth.currentUser || auth.currentUser.isAnonymous) && this.state.id === null) {
          return (
              <Grid>
                {this.breadcumb()}
                  <Row>
                      <PageHeader>Profile</PageHeader>
                  </Row>
                <Row>
                  Please <a href="/login">Login</a> to view your profile
                </Row>
              </Grid>
          );
      }


    const { match } = this.props;

    return (
    <Grid>
      {this.breadcumb()}
        <Row>
          <PageHeader>Profile</PageHeader>
        </Row>
        <Row>
          Profile Page: user: {this.state.id}
        </Row>
        <Row>
          <br/>
          url: {match.url}
          <br/>
          path: {match.path}
          <br/>
          userData: {userData!==null?"there":"not there"}
          <br/>
          isAdmin: {isAdmin?"true":"false"}
        </Row>
      </Grid>
    );
  }
}
export default withRouter(Profile);



// WEBPACK FOOTER //
// ./src/pages/Profile.jsx